var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bodybox"},[_c('div',{staticClass:"topbox"},[_c('Top')],1),_c('div',{staticClass:"bigbox"},[_c('div',{staticClass:"modularBox "},[_c('router-view')],1),_c('div',{staticClass:"bottombox"},[_c('Bottom')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }